export default __webpack_public_path__ + "canva.4f26abee.png";